import './buttonSelector.scss';

import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';

const ButtonSelector = ({
  onClick,
  className,
  icon,
  expandable,
  children,
}: {
  onClick: any;
  className: string;
  icon?: any;
  expandable?: boolean;
  children: any;
}): JSX.Element => (
  <button type="button" className={className} onClick={onClick}>
    {icon && <div className="icon-container">{icon}</div>}
    <div className="text-container">{children}</div>
    {expandable && (
      <div className="arrow-container">
        <FontAwesomeIcon icon={faChevronDown} />
      </div>
    )}
  </button>
);

export default ButtonSelector;
